export const ReducerCases = {
    Login: "Login",
    Logout: "Logout",
    UpdateDetails: "UpdateDetails",
    UpdateLoading: "UpdateLoading",
}
export const ResStatus ={
    Success: 1,
    Failure: 0,
}
export const Strings = {
    Error: "Something Went Wrong",
}
export const Alerts = {
    Error: {type: 'error',message: "Something Went Wrong"},

}
export const CustomArray ={
    Status: ['No Whatsapp','Duplicate','No Group','Active','Completed'],
}

export const Colors ={
    Primary: '#075E54'
}

export const Defaults ={
    AppName: "Read365Books"
}
